import { render } from "./SelectMultiAutocompleteLabel.vue?vue&type=template&id=656dc380&scoped=true"
import script from "./SelectMultiAutocompleteLabel.vue?vue&type=script&lang=ts"
export * from "./SelectMultiAutocompleteLabel.vue?vue&type=script&lang=ts"

import "./SelectMultiAutocompleteLabel.vue?vue&type=style&index=0&id=656dc380&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-656dc380"

export default script